export default `
{{#> page centered=1 scroll=1}}
  {{> network-error type="500" clarification="Мы уже чиним" }}
{{/page}}

`;
